import React from 'react';
import { Stack, Typography, Link, styled } from '@mui/material';
import { ReactComponent as ArcBrowserFaceIcon } from 'assets/images/arc-browser-face.svg';
import { getCallCenterLink } from 'utils';
import { ButtonContained } from 'components/Button';

const Root = styled(Stack)(() => ({
  height: '100vh',
  margin: '-8px',
}));

const Content = styled(Stack)(() => ({
  flex: 1,
  margin: '0 3rem',
}));

const Title = styled(Typography)(() => ({
  fontFamily: 'DM Sans, Arial',
  fontWeight: 500,
  fontSize: '1.25rem',
  lineHeight: '1.625rem',
  textAlign: 'center',
}));

const Text = styled(Typography)(() => ({
  fontFamily: 'DM Sans, Arial',
  fontWeight: 400,
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  textAlign: 'center',
}));

const SupportLink = styled(Link)(() => ({
  fontFamily: 'DM Sans, Arial',
  color: '#6948EB',
  fontWeight: 500,
  textDecorationColor: '#6948EB',
}));

const ReloadButton = styled(ButtonContained)(({ theme }) => ({
  fontFamily: 'DM Sans, Arial',
  maxWidth: '100%',
  fontSize: '1rem',
  lineHeight: '1.1875rem',
  fontWeight: 700,
  borderRadius: '100px',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none !important',
    backgroundColor: '#6948EB',
    color: '#FEFEFE',
  },
  padding: '16.5px 22px',
  textTransform: 'none',
  backgroundColor: '#6948EB',
  color: '#FEFEFE',
  [theme.breakpoints.up('md')]: {
    maxWidth: '400px',
  },
}));

export const ErrorBoundaryFallback = () => {
  const { tel } = getCallCenterLink();

  return (
    <Root flexDirection="column">
      <Content flexDirection="column" justifyContent="center" alignItems="center" gap="2rem">
        <ArcBrowserFaceIcon width="11vh" height="11vh" />
        <Title>Algo salió mal</Title>
        <Text>
          ¡Hola! Estamos al tanto de que se están presentando algunos inconvenientes al navegar por nuestra web.
          <br />
          Te pedimos que si el problema persiste, contactes a nuestro equipo de soporte vía{' '}
          <SupportLink href={`tel:${tel}`}>telefónica</SupportLink> o chat.
        </Text>
        <ReloadButton
          onClick={() => {
            window.location.reload();
          }}
          label="Inténtelo de nuevo"
        />
      </Content>
    </Root>
  );
};
